import React from 'react';

function Download(props) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9 12" {...props}>
      <g clipPath="url(#clip0)">
        <path d="M4.5 0c-.3 0-.5.2-.5.5v7.7l-3.1-3a.5.5 0 00-.7 0c-.2.1-.2.4 0 .6l4 4H5l4-4c.2-.2.2-.5 0-.7a.5.5 0 00-.7 0L5 8.2V.5c0-.3-.2-.5-.5-.5zM.5 12h8a.5.5 0 100-1h-8a.5.5 0 100 1z" />
      </g>
      <defs>
        <clipPath id="clip0">
          <path fill="#fff" d="M0 0h9v12H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Download;
